import { Progress } from "@heroui/react"

const Loading = ({icon, text})=>{

    return (
        <div class="flex justify-center items-center h-screen backdrop-blur-md">
            <div className="flex-col justify-center items-center space-y-4">
                <div className="flex justify-center self-center item-center">
                {icon && icon}
                </div>

                <div>
                <Progress isIndeterminate aria-label="Loading..." className="max-w-lg text-primary" size="sm" />
                </div>
                {text && <p>{text}</p>}
            </div>
        </div>
    )
}

export default Loading